import { useRef } from 'react';
/**
 * Show a warning message in development environment when condition being hit.
 */
// istanbul ignore next
export default function useDevelopmentWarning(condition, message) {
    if (process.env.NODE_ENV === undefined ||
        process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const warnedRef = useRef(false);
        if (!warnedRef.current && condition()) {
            // eslint-disable-next-line no-console
            console.warn(message);
            warnedRef.current = true;
        }
    }
}
